export const CDF: { [key: string]: string } = {
  '0': '500000000000000000',
  '10000000000000000': '503989356314631616',
  '20000000000000000': '507978313716901952',
  '30000000000000000': '511966473414112640',
  '40000000000000000': '515953436852830784',
  '50000000000000000': '519938805838372480',
  '60000000000000000': '523922182654106816',
  '70000000000000000': '527903170180521152',
  '80000000000000000': '531881372013987456',
  '90000000000000000': '535856392585172160',
  '100000000000000000': '539827837277028992',
  '110000000000000000': '543795312542316864',
  '120000000000000000': '547758426020583872',
  '130000000000000000': '551716786654561152',
  '140000000000000000': '555670004805906432',
  '150000000000000000': '559617692370242496',
  '160000000000000000': '563559462891432896',
  '170000000000000000': '567494931675038400',
  '180000000000000000': '571423715900900672',
  '190000000000000000': '575345434734795520',
  '200000000000000000': '579259709439102976',
  '210000000000000000': '583166163482442368',
  '220000000000000000': '587064422648214528',
  '230000000000000000': '590954115142005888',
  '240000000000000000': '594834871697795840',
  '250000000000000000': '598706325682923648',
  '260000000000000000': '602568113201760512',
  '270000000000000000': '606419873198039424',
  '280000000000000000': '610261247555797248',
  '290000000000000000': '614091881198877312',
  '300000000000000000': '617911422188952704',
  '310000000000000000': '621719521822019328',
  '320000000000000000': '625515834723320064',
  '330000000000000000': '629300018940653440',
  '340000000000000000': '633071736036028032',
  '350000000000000000': '636830651175619072',
  '360000000000000000': '640576433217991296',
  '370000000000000000': '644308754800546688',
  '380000000000000000': '648027292424162816',
  '390000000000000000': '651731726535982464',
  '400000000000000000': '655421741610324224',
  '410000000000000000': '659097026227677440',
  '420000000000000000': '662757273151750528',
  '430000000000000000': '666402179404542208',
  '440000000000000000': '670031446339406336',
  '450000000000000000': '673644779712080000',
  '460000000000000000': '677241889749652352',
  '470000000000000000': '680822491217444224',
  '480000000000000000': '684386303483777408',
  '490000000000000000': '687933050582609408',
  '500000000000000000': '691462461274013056',
  '510000000000000000': '694974269102480640',
  '520000000000000000': '698468212453033856',
  '530000000000000000': '701944034605123584',
  '540000000000000000': '705401483784301952',
  '550000000000000000': '708840313211653632',
  '560000000000000000': '712260281150973056',
  '570000000000000000': '715661150953675904',
  '580000000000000000': '719042691101435648',
  '590000000000000000': '722404675246535168',
  '600000000000000000': '725746882249926400',
  '610000000000000000': '729069096216994176',
  '620000000000000000': '732371106531016960',
  '630000000000000000': '735652707884322432',
  '640000000000000000': '738913700307138432',
  '650000000000000000': '742153889194135296',
  '660000000000000000': '745373085328663808',
  '670000000000000000': '748571104904689920',
  '680000000000000000': '751747769546429696',
  '690000000000000000': '754902906325690496',
  '700000000000000000': '758036347776926976',
  '710000000000000000': '761147931910013440',
  '720000000000000000': '764237502220748800',
  '730000000000000000': '767304907699102592',
  '740000000000000000': '770350002835209216',
  '750000000000000000': '773372647623131776',
  '760000000000000000': '776372707562400512',
  '770000000000000000': '779350053657350272',
  '780000000000000000': '782304562414266880',
  '790000000000000000': '785236115836363008',
  '800000000000000000': '788144601416603264',
  '810000000000000000': '791029912128398592',
  '820000000000000000': '793891946414186880',
  '830000000000000000': '796730608171931392',
  '840000000000000000': '799545806739550208',
  '850000000000000000': '802337456877307648',
  '860000000000000000': '805105478748191616',
  '870000000000000000': '807849797896304000',
  '880000000000000000': '810570345223287936',
  '890000000000000000': '813267056962827392',
  '900000000000000000': '815939874653240448',
  '910000000000000000': '818588745108202752',
  '920000000000000000': '821213620385628416',
  '930000000000000000': '823814457754742144',
  '940000000000000000': '826391219661375360',
  '950000000000000000': '828943873691518208',
  '960000000000000000': '831472392533162240',
  '970000000000000000': '833976753936470400',
  '980000000000000000': '836456940672307456',
  '990000000000000000': '838912940489169152',
  '1000000000000000000': '841344746068542848',
  '1010000000000000000': '843752354978745344',
  '1020000000000000000': '846135769627265152',
  '1030000000000000000': '848494997211656448',
  '1040000000000000000': '850830049669018624',
  '1050000000000000000': '853140943624104192',
  '1060000000000000000': '855427700336090624',
  '1070000000000000000': '857690345644060800',
  '1080000000000000000': '859928909911231104',
  '1090000000000000000': '862143427967964544',
  '1100000000000000000': '864333939053617280',
  '1110000000000000000': '866500486757252736',
  '1120000000000000000': '868643118957269248',
  '1130000000000000000': '870761887759982336',
  '1140000000000000000': '872856849437201792',
  '1150000000000000000': '874928064362849664',
  '1160000000000000000': '876975596948656512',
  '1170000000000000000': '878999515578981760',
  '1180000000000000000': '880999892544799232',
  '1190000000000000000': '882976803976891264',
  '1200000000000000000': '884930329778291840',
  '1210000000000000000': '886860553556022528',
  '1220000000000000000': '888767562552165376',
  '1230000000000000000': '890651447574308096',
  '1240000000000000000': '892512302925413120',
  '1250000000000000000': '894350226333144704',
  '1260000000000000000': '896165318878699648',
  '1270000000000000000': '897957684925181056',
  '1280000000000000000': '899727432045557888',
  '1290000000000000000': '901474670950252160',
  '1300000000000000000': '903199515414389760',
  '1310000000000000000': '904902082204761088',
  '1320000000000000000': '906582491006528384',
  '1330000000000000000': '908240864349719296',
  '1340000000000000000': '909877327535547648',
  '1350000000000000000': '911492008562598144',
  '1360000000000000000': '913085038052914944',
  '1370000000000000000': '914656549178033152',
  '1380000000000000000': '916206677584985728',
  '1390000000000000000': '917735561322331008',
  '1400000000000000000': '919243340766228864',
  '1410000000000000000': '920730158546607488',
  '1420000000000000000': '922196159473453568',
  '1430000000000000000': '923641490463261056',
  '1440000000000000000': '925066300465672960',
  '1450000000000000000': '926470740390351616',
  '1460000000000000000': '927854963034106368',
  '1470000000000000000': '929219123008314496',
  '1480000000000000000': '930563376666668288',
  '1490000000000000000': '931887882033274624',
  '1500000000000000000': '933192798731142016',
  '1510000000000000000': '934478287911083392',
  '1520000000000000000': '935744512181064192',
  '1530000000000000000': '936991635536021632',
  '1540000000000000000': '938219823288188032',
  '1550000000000000000': '939429241997940992',
  '1560000000000000000': '940620059405207040',
  '1570000000000000000': '941792444361446912',
  '1580000000000000000': '942946566762245888',
  '1590000000000000000': '944082597480530560',
  '1600000000000000000': '945200708300442240',
  '1610000000000000000': '946301071851880320',
  '1620000000000000000': '947383861545747968',
  '1630000000000000000': '948449251509910528',
  '1640000000000000000': '949497416525896192',
  '1650000000000000000': '950528531966352000',
  '1660000000000000000': '951542773733277184',
  '1670000000000000000': '952540318197052928',
  '1680000000000000000': '953521342136280064',
  '1690000000000000000': '954486022678450176',
  '1700000000000000000': '955434537241457152',
  '1710000000000000000': '956367063475968000',
  '1720000000000000000': '957283779208670976',
  '1730000000000000000': '958184862386405120',
  '1740000000000000000': '959070491021192960',
  '1750000000000000000': '959940843136182912',
  '1760000000000000000': '960796096712517504',
  '1770000000000000000': '961636429637128704',
  '1780000000000000000': '962462019651483264',
  '1790000000000000000': '963273044301273856',
  '1800000000000000000': '964069680887074176',
  '1810000000000000000': '964852106415961472',
  '1820000000000000000': '965620497554110336',
  '1830000000000000000': '966375030580371712',
  '1840000000000000000': '967115881340836224',
  '1850000000000000000': '967843225204386432',
  '1860000000000000000': '968557237019247488',
  '1870000000000000000': '969258091070534016',
  '1880000000000000000': '969945961038800256',
  '1890000000000000000': '970621019959590656',
  '1900000000000000000': '971283440183998080',
  '1910000000000000000': '971933393340227456',
  '1920000000000000000': '972571050296163328',
  '1930000000000000000': '973196581122945024',
  '1940000000000000000': '973810155059547264',
  '1950000000000000000': '974411940478361344',
  '1960000000000000000': '975002104851779584',
  '1970000000000000000': '975580814719777280',
  '1980000000000000000': '976148235658491392',
  '1990000000000000000': '976704532249788288',
  '2000000000000000000': '977249868051820928',
  '2010000000000000000': '977784405570568448',
  '2020000000000000000': '978308306232353152',
  '2030000000000000000': '978821730357327872',
  '2040000000000000000': '979324837133929984',
  '2050000000000000000': '979817784594295680',
  '2060000000000000000': '980300729590623104',
  '2070000000000000000': '980773827772482944',
  '2080000000000000000': '981237233565062400',
  '2090000000000000000': '981691100148341120',
  '2100000000000000000': '982135579437183488',
  '2110000000000000000': '982570822062343040',
  '2120000000000000000': '982996977352367360',
  '2130000000000000000': '983414193316395136',
  '2140000000000000000': '983822616627833984',
  '2150000000000000000': '984222392608909568',
  '2160000000000000000': '984613665216074368',
  '2170000000000000000': '984996577026267904',
  '2180000000000000000': '985371269224010880',
  '2190000000000000000': '985737881589331200',
  '2200000000000000000': '986096552486501504',
  '2210000000000000000': '986447418853579904',
  '2220000000000000000': '986790616192743936',
  '2230000000000000000': '987126278561398144',
  '2240000000000000000': '987454538564053376',
  '2250000000000000000': '987775527344955392',
  '2260000000000000000': '988089374581452928',
  '2270000000000000000': '988396208478096512',
  '2280000000000000000': '988696155761447168',
  '2290000000000000000': '988989341675588608',
  '2300000000000000000': '989275889978324224',
  '2310000000000000000': '989555922938049024',
  '2320000000000000000': '989829561331280384',
  '2330000000000000000': '990096924440835712',
  '2340000000000000000': '990358130054641536',
  '2350000000000000000': '990613294465161600',
  '2360000000000000000': '990862532469427328',
  '2370000000000000000': '991105957369663232',
  '2380000000000000000': '991343680974483328',
  '2390000000000000000': '991575813600654336',
  '2400000000000000000': '991802464075403904',
  '2410000000000000000': '992023739739266432',
  '2420000000000000000': '992239746449446400',
  '2430000000000000000': '992450588583690752',
  '2440000000000000000': '992656369044651648',
  '2450000000000000000': '992857189264728832',
  '2460000000000000000': '993053149211375616',
  '2470000000000000000': '993244347392859648',
  '2480000000000000000': '993430880864453248',
  '2490000000000000000': '993612845235057024',
  '2500000000000000000': '993790334674224000',
  '2510000000000000000': '993963441919587328',
  '2520000000000000000': '994132258284667392',
  '2530000000000000000': '994296873667049344',
  '2540000000000000000': '994457376556917376',
  '2550000000000000000': '994613854045933440',
  '2560000000000000000': '994766391836444160',
  '2570000000000000000': '994915074251009152',
  '2580000000000000000': '995059984242229376',
  '2590000000000000000': '995201203402873856',
  '2600000000000000000': '995338811976281216',
  '2610000000000000000': '995472888867032832',
  '2620000000000000000': '995603511651878656',
  '2630000000000000000': '995730756590910848',
  '2640000000000000000': '995854698638963968',
  '2650000000000000000': '995975411457241728',
  '2660000000000000000': '996092967425147264',
  '2670000000000000000': '996207437652314624',
  '2680000000000000000': '996318891990824960',
  '2690000000000000000': '996427399047600128',
  '2700000000000000000': '996533026196959360',
  '2710000000000000000': '996635839593330944',
  '2720000000000000000': '996735904184108672',
  '2730000000000000000': '996833283722642176',
  '2740000000000000000': '996928040781349504',
  '2750000000000000000': '997020236764945408',
  '2760000000000000000': '997109931923773952',
  '2770000000000000000': '997197185367234944',
  '2780000000000000000': '997282055077298688',
  '2790000000000000000': '997364597922095104',
  '2800000000000000000': '997444869669571968',
  '2810000000000000000': '997522925001214208',
  '2820000000000000000': '997598817525810816',
  '2830000000000000000': '997672599793268480',
  '2840000000000000000': '997744323308457728',
  '2850000000000000000': '997814038545086720',
  '2860000000000000000': '997881794959595264',
  '2870000000000000000': '997947641005060480',
  '2880000000000000000': '998011624145105664',
  '2890000000000000000': '998073790867812096',
  '2900000000000000000': '998134186699615872',
  '2910000000000000000': '998192856219193600',
  '2920000000000000000': '998249843071323776',
  '2930000000000000000': '998305189980722944',
  '2940000000000000000': '998358938765843072',
  '2950000000000000000': '998411130352635264',
  '2960000000000000000': '998461804788262016',
  '2970000000000000000': '998511001254762624',
  '2980000000000000000': '998558758082660096',
  '2990000000000000000': '998605112764507904',
  '3000000000000000000': '998650101968370048',
  '3010000000000000000': '998693761551230592',
  '3020000000000000000': '998736126572327808',
  '3030000000000000000': '998777231306407808',
  '3040000000000000000': '998817109256895488',
  '3050000000000000000': '998855793168977664',
  '3060000000000000000': '998893315042590720',
  '3070000000000000000': '998929706145321216',
  '3080000000000000000': '998964997025197184',
  '3090000000000000000': '998999217523386240',
  '3100000000000000000': '999032396786781568',
  '3110000000000000000': '999064563280486144',
  '3120000000000000000': '999095744800177792',
  '3130000000000000000': '999125968484368640',
  '3140000000000000000': '999155260826541440',
  '3150000000000000000': '999183647687171328',
  '3160000000000000000': '999211154305624320',
  '3170000000000000000': '999237805311932672',
  '3180000000000000000': '999263624738446080',
  '3190000000000000000': '999288636031354624',
  '3200000000000000000': '999312862062084224',
  '3210000000000000000': '999336325138559872',
  '3220000000000000000': '999359047016339968',
  '3230000000000000000': '999381048909613056',
  '3240000000000000000': '999402351502065536',
  '3250000000000000000': '999422974957609344',
  '3260000000000000000': '999442938930975360',
  '3270000000000000000': '999462262578170368',
  '3280000000000000000': '999480964566793216',
  '3290000000000000000': '999499063086214400',
  '3300000000000000000': '999516575857616256',
  '3310000000000000000': '999533520143892480',
  '3320000000000000000': '999549912759408000',
  '3330000000000000000': '999565770079618304',
  '3340000000000000000': '999581108050549632',
  '3350000000000000000': '999595942198135936',
  '3360000000000000000': '999610287637417984',
  '3370000000000000000': '999624159081600000',
  '3380000000000000000': '999637570850967296',
  '3390000000000000000': '999650536881662208',
  '3400000000000000000': '999663070734323200',
  '3410000000000000000': '999675185602580992',
  '3420000000000000000': '999686894321418880',
  '3430000000000000000': '999698209375391488',
  '3440000000000000000': '999709142906709376',
  '3450000000000000000': '999719706723184000',
  '3460000000000000000': '999729912306036608',
  '3470000000000000000': '999739770817572736',
  '3480000000000000000': '999749293108719488',
  '3490000000000000000': '999758489726432256',
  '3500000000000000000': '999767370920964352',
  '3510000000000000000': '999775946653008896',
  '3520000000000000000': '999784226600705280',
  '3530000000000000000': '999792220166519552',
  '3540000000000000000': '999799936483992704',
  '3550000000000000000': '999807384424364288',
  '3560000000000000000': '999814572603066496',
  '3570000000000000000': '999821509386094976',
  '3580000000000000000': '999828202896254208',
  '3590000000000000000': '999834661019280128',
  '3600000000000000000': '999840891409842176',
  '3610000000000000000': '999846901497426048',
  '3620000000000000000': '999852698492092544',
  '3630000000000000000': '999858289390124160',
  '3640000000000000000': '999863680979554304',
  '3650000000000000000': '999868879845579520',
  '3660000000000000000': '999873892375861248',
  '3670000000000000000': '999878724765714560',
  '3680000000000000000': '999883383023184640',
  '3690000000000000000': '999887872974017792',
  '3700000000000000000': '999892200266522624',
  '3710000000000000000': '999896370376326016',
  '3720000000000000000': '999900388611024512',
  '3730000000000000000': '999904260114731264',
  '3740000000000000000': '999907989872526208',
  '3750000000000000000': '999911582714799232',
  '3760000000000000000': '999915043321501824',
  '3770000000000000000': '999918376226297472',
  '3780000000000000000': '999921585820616576',
  '3790000000000000000': '999924676357621248',
  '3800000000000000000': '999927651956074880',
  '3810000000000000000': '999930516604120192',
  '3820000000000000000': '999933274162970240',
  '3830000000000000000': '999935928370511104',
  '3840000000000000000': '999938482844816768',
  '3850000000000000000': '999940941087581056',
  '3860000000000000000': '999943306487465728',
  '3870000000000000000': '999945582323366400',
  '3880000000000000000': '999947771767598464',
  '3890000000000000000': '999949877889003776',
  '3900000000000000000': '999951903655982336',
  '3910000000000000000': '999953851939443840',
  '3920000000000000000': '999955725515688064',
  '3930000000000000000': '999957527069211392',
  '3940000000000000000': '999959259195441408',
  '3950000000000000000': '999960924403402240',
  '3960000000000000000': '999962525118308864',
  '3970000000000000000': '999964063684097408',
  '3980000000000000000': '999965542365885056',
  '3990000000000000000': '999966963352370304',
  '4000000000000000000': '999968328758166912'
};
